import { useSyncExternalStore } from "react";

/* Ten sam próg co wariant `md:` Tailwinda — przy zmianie skali `screens` popraw oba miejsca. */
const DESKTOP_MEDIA_QUERY = "(min-width: 768px)";

const subscribe = (onChange: () => void) => {
  const mediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
  mediaQuery.addEventListener("change", onChange);
  return () => mediaQuery.removeEventListener("change", onChange);
};

const getSnapshot = () => window.matchMedia(DESKTOP_MEDIA_QUERY).matches;

export const useIsDesktop = (): boolean => useSyncExternalStore(subscribe, getSnapshot);
